function update_cart_drawer_message(cart){
  var min_lineItems = cart.items.filter(item => item.properties.hasOwnProperty('_min_qty_limit'));
  var min_increment_lineItems = cart.items.filter(item => item.properties.hasOwnProperty('_increment_step'));
  min_increment_lineItems.forEach(lineItem => {
  if(parseInt(lineItem.properties._increment_step) > 1){
      document.querySelectorAll('.cart_item_grid').forEach(function(cart_grid, grid_idx){
        if(cart_grid.getAttribute('data-cart-key') == lineItem.key){
          cart_grid.querySelectorAll('.show_qty_increment_message').forEach(function(error_grid, error_idx){
            error_grid.style.display = '';
            if(error_grid.querySelector('.show_qty_increment_message_text')){
              error_grid.querySelector('.show_qty_increment_message_text span').innerHTML = lineItem.properties._increment_step;
            }
          });
        }
      });
    }
  });
  min_lineItems.forEach(lineItem => {
    if(lineItem.properties &&  lineItem.properties.hasOwnProperty('_min_qty_limit') && lineItem.quantity < parseInt(lineItem.properties._min_qty_limit)){
      CartJS.updateItemById(lineItem.key,parseInt(lineItem.properties._min_qty_limit));
      setTimeout(() => {
        document.querySelectorAll('.cart_item_grid').forEach(function(cart_grid, grid_idx){
          if(cart_grid.getAttribute('data-cart-key') == lineItem.key){
            cart_grid.querySelectorAll('.show_qty_error_message').forEach(function(error_grid, error_idx){
              error_grid.style.display = '';
              if(error_grid.querySelector('.show_qty_error_message_text')){
                error_grid.querySelector('.show_qty_error_message_text span').innerHTML = lineItem.properties._min_qty_limit;
              }
            });
          }
        });
      }, "2000");
    } else{
      document.querySelectorAll('.cart_item_grid').forEach(function(cart_grid, grid_idx){
        if(cart_grid.getAttribute('data-cart-key') == lineItem.key){
          cart_grid.querySelectorAll('.show_qty_error_message').forEach(function(error_grid, error_idx){
            error_grid.style.display = 'none';
            if(error_grid.querySelector('.show_qty_error_message_text')){
              error_grid.querySelector('.show_qty_error_message_text span').innerHTML = lineItem.properties._min_qty_limit;
            }
          });
        }
      });
    }
  });
}

$(document).on('cart.requestComplete', function (event, cart){
  update_cart_drawer_message(cart);
});

document.addEventListener("DOMContentLoaded", function(event){
  fetch('/cart.js', {
    method: 'GET',
  }).then(response => response.json()).then(cart => {
    update_cart_drawer_message(cart);
  }).catch($th_cart_error => {
    console.error($th_cart_error);
  });
});